import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiTablePagination = (baseTheme: Theme): Partial<Components> => ({
  MuiTablePagination: {
    styleOverrides: {
      root: {
        [baseTheme.breakpoints.down('lg')]: {
          transform: 'scale(0.9)',
        },
      },
      toolbar: {
        height: '64px',
        [baseTheme.breakpoints.down('lg')]: {
          paddingLeft: '0',
        },
      },
      actions: {
        'button:disabled svg path': {
          fill: baseTheme.palette.grey[400],
        },
      },
    },
  },
});
